<template>
    <div>
        <div v-if="loading" class="loading"></div>
        <div v-if="dashboardData">
            <b-row class="mb-4">
                <b-colxx xxs="12">
                    <span class="h3">{{ greetings() }}</span><span
                    class="text-muted h4">{{authUserInfo.attributes.name}}!</span>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx lg="12" md="6" xl="4">
                    <gradient-card>
<!--                        <div class="wrapper mb-3">-->
<!--                            <div class="focus text-truncate text-paragraph">-->
<!--                                HMS-->
<!--                            </div>-->
<!--                            <div class="mask text-truncate text-paragraph">-->
<!--                                <div class="text">HMS</div>-->
<!--                            </div>-->
<!--                        </div>-->
                        <p class="lead text-white">HMS</p>
                        <p class="text-white">Housing Management Project.</p>
                    </gradient-card>
                </b-colxx>
                <b-colxx v-if="todos" lg="4" xl="4" class="mb-4">
                    <b-card>
                        <div class="d-flex flex-row">
                            <i class="iconsminds-check text-large mb-2 mr-3 menu-icon-style"/>
                            <div class="my-auto">
                                <div class="d-inline-block mb-2">
                                    <h5 class="d-inline">TO-DO LIST</h5>
                                    <span class="text-muted text-small d-block">All Tasks</span>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent="addNewTodo">
                            <b-input-group>
                                <b-form-input id="pop-error" v-model="todoForm.title"
                                              @input="$root.$emit('bv::hide::tooltip', 'todo-error') && 'title' in todoErrors ? (delete todoErrors.title) : ''"
                                              placeholder="Add todo here" autocomplete="off"/>
                                <b-input-group-append>
                                    <b-button type="submit" class="px-3" style="font-size: 26px"
                                              size="xs" variant="outline-primary">
                                        <b>+</b>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <b-tooltip target="pop-error" id="todo-error" triggers="manual" placement="bottom">
                                <span class="text-danger">{{ 'title' in todoErrors ? todoErrors.title[0] : '' }}</span>
                            </b-tooltip>
                        </form>
                        <vue-perfect-scrollbar class="scroll dashboard-todo-list"
                                               :settings="{ suppressScrollX: true, wheelPropagation: false }">
                            <b-row class="mb-4 pb-3 mt-4">
                                <b-colxx lg="12" v-if="todos.length > 0" v-for="(todo, index) in todos"
                                         :key="todo.todo_id">
                                    <b-row>
                                        <b-colxx lg="10" xxs="10" class="text-truncate text-paragraph bold">
                                            <b-form-checkbox class="w-100" v-model="todo.data.attributes.completed"
                                                             @input="editTodo(todo.todo_id, index)">
                                        <span class="pl-1"
                                              :class="{'text-strikethrough': todo.data.attributes.completed}">
                                            {{ todo.data.attributes.title }}
                                        </span>
                                            </b-form-checkbox>
                                        </b-colxx>
                                        <b-colxx lg="2" xxs="2">
                                            <span
                                                @click="deleteTodo(todo.todo_id, todo.data.attributes.completed, index)"
                                                class="h5 iconsminds-remove float-right"
                                                :class="todo.data.attributes.completed ? 'text-danger' : 'text-muted'"/>
                                        </b-colxx>
                                    </b-row>
                                </b-colxx>
                                <b-colxx lg="12" v-if="todos.length <= 0">
                                    <p>There are no to-dos to show.</p>
                                </b-colxx>
                            </b-row>
                        </vue-perfect-scrollbar>
                    </b-card>
                </b-colxx>
                <b-colxx lg="12" md="6" xl="4">
                    <b-row>
                        <b-colxx lg="4" xl="12" class="mb-4">
                            <b-card>
                                <div class="d-flex flex-row">
                                    <i class="iconsminds-profile text-large mb-4 mr-3 menu-icon-style"/>
                                    <div class="my-auto">
                                        <div class="d-inline-block mb-4">
                                            <h5 class="d-inline">CLIENTS INFORMATION</h5>
                                            <span class="text-muted text-small d-block">Current Month</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-4">
                                    <p class="mb-2">
                                        Clients Admitted | {{dashboardData.attributes.current_month.admissions.count}}
                                        <span class="float-right text-muted">{{dashboardData.attributes.current_month.admissions.percentage}}%</span>
                                    </p>
                                    <b-progress variant="secondary"
                                                :value="dashboardData.attributes.current_month.admissions.percentage"></b-progress>
                                </div>
                                <div class="mb-1">
                                    <p class="mb-2">
                                        Clients No-show | {{dashboardData.attributes.current_month.noshows.count}}
                                        <span class="float-right text-muted">{{dashboardData.attributes.current_month.noshows.percentage}}%</span>
                                    </p>
                                    <b-progress variant="secondary"
                                                :value="dashboardData.attributes.current_month.noshows.percentage"></b-progress>
                                </div>
                            </b-card>
                        </b-colxx>

                        <b-colxx lg="4" xl="12" class="mb-4">
                            <b-card class="bg-theme-2">
                                <div class="position-absolute card-top-buttons">
                                    <div v-b-modal.modalbasic-1 class="btn btn-header-light-2 icon-button mt-n4 mr-n4">
                                        <i class="simple-icon-info" />
                                    </div>
                                    <b-modal id="modalbasic-4" ref="modalbasic-4" title="Occupency">
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                        sed do eiusmod tempor incididunt ut labore et dolore magna
                                        aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                                        ullamco laboris nisi ut aliquip ex ea commodo consequat.
                                        Duis aute irure dolor in reprehenderit in voluptate velit
                                        esse cillum dolore eu fugiat nulla pariatur. Excepteur
                                        sint occaecat cupidatat non proident, sunt in culpa qui
                                        officia deserunt mollit anim id est laborum. modal-4...
                                        <template slot="modal-footer">
                                            <b-button variant="secondary" @click="hideModal('modalbasic-4')">Okay!</b-button>
                                        </template>
                                    </b-modal>
                                </div>

                                <div class="d-flex flex-row">
                                    <div class="my-auto">
                                        <div class="d-inline-block mb-4">
                                            <h5 class="d-inline">Total Referral | {{dashboardData.attributes.current_month.referrals}}</h5>
                                            <span class="text-small d-block">Current Month</span>
                                        </div>
                                    </div>
                                </div>

                                <div>
<!--                                    <b-progress variant="secondary" class="mb-2"-->
<!--                                                :value="dashboardData.attributes.current_month.admissions.percentage"></b-progress>-->
                                    <span>
                                        <b-badge pill variant="light">Clients Discharged | {{dashboardData.attributes.current_month.discharges}}</b-badge>

                                    <span class="float-right"><b-badge pill variant="light">Clients Transferred | {{dashboardData.attributes.current_month.transfers}}</b-badge></span>
                                    </span>
                                </div>
                            </b-card>
                        </b-colxx>
                    </b-row>
                </b-colxx>
            </b-row>

            <div class="row">
                <b-colxx xl="3" lg="6" class="mb-4">
                    <radial-progress-card
                        :title="'Vendors | ' + dashboardData.attributes.active.vendors.count.toString()"
                        secondary-title="Active" :percent="dashboardData.attributes.active.vendors.percentage"
                        no-suffle=""/>
                </b-colxx>
                <b-colxx xl="3" lg="6" class="mb-4">
                    <radial-progress-card
                        :title="'Facilities | ' + dashboardData.attributes.active.facilities.count.toString()"
                        secondary-title="Active" :percent="dashboardData.attributes.active.facilities.percentage"
                        no-suffle=""/>
                </b-colxx>
                <b-colxx xl="3" lg="6" class="mb-4">
                    <radial-progress-card
                        :title="'Single Units | ' + dashboardData.attributes.active.single_units.count.toString()"
                        secondary-title="Active" :percent="dashboardData.attributes.active.single_units.percentage"
                        no-suffle=""/>
                </b-colxx>
                <b-colxx xl="3" lg="6" class="mb-4">
                    <radial-progress-card
                        :title="'Family Units | ' + dashboardData.attributes.active.family_units.count.toString()"
                        secondary-title="Active" :percent="dashboardData.attributes.active.family_units.percentage"
                        no-suffle=""/>
                </b-colxx>
            </div>

            <div class="row">
                <b-colxx lg="4" class="mb-4">
                    <b-card class="bg-theme-3">
                        <div class="position-absolute card-top-buttons">
                            <div v-b-modal.modalbasic-1 class="btn btn-header-light-2 icon-button mt-n4 mr-n4">
                                <i class="simple-icon-info" />
                            </div>
                            <b-modal id="modalbasic-1" ref="modalbasic-1" title="Summary of Active Units">
                                <b-table :items="dashboardData.attributes.units.table" />
                                <template slot="modal-footer">
                                    <b-button variant="secondary" @click="hideModal('modalbasic-1')">Okay!</b-button>
                                </template>
                            </b-modal>
                        </div>

                        <div class="d-flex flex-row">
                            <div class="my-auto">
                                <div class="d-inline-block mb-4">
                                    <h5 class="d-inline">Total Units | {{ dashboardData.attributes.units.total }}</h5>
                                    <span class="text-small d-block">From the Beginning</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <b-progress variant="secondary" class="mb-2"
                                        :value="dashboardData.attributes.units.active.percentage"></b-progress>
                            <span>
                                Active Units | {{ dashboardData.attributes.units.active.count }}
                                <span class="float-right">{{dashboardData.attributes.units.active.percentage}}%</span>
                            </span>
                        </div>
                    </b-card>
                </b-colxx>

                <b-colxx lg="4" class="mb-4">
                    <b-card class="bg-theme-3">
<!--                        <div class="position-absolute card-top-buttons">-->
<!--                            <div v-b-modal.modalbasic-2 class="btn btn-header-light-2 icon-button mt-n4 mr-n4">-->
<!--                                <i class="simple-icon-info" />-->
<!--                            </div>-->
<!--                            <b-modal id="modalbasic-2" ref="modalbasic-2" title="Clients">-->
<!--                                Lorem ipsum dolor sit amet, consectetur adipisicing elit,-->
<!--                                sed do eiusmod tempor incididunt ut labore et dolore magna-->
<!--                                aliqua. Ut enim ad minim veniam, quis nostrud exercitation-->
<!--                                ullamco laboris nisi ut aliquip ex ea commodo consequat.-->
<!--                                Duis aute irure dolor in reprehenderit in voluptate velit-->
<!--                                esse cillum dolore eu fugiat nulla pariatur. Excepteur-->
<!--                                sint occaecat cupidatat non proident, sunt in culpa qui-->
<!--                                officia deserunt mollit anim id est laborum.-->
<!--                                <template slot="modal-footer">-->
<!--                                    <b-button variant="secondary" @click="hideModal('modalbasic-2')">Okay!</b-button>-->
<!--                                </template>-->
<!--                            </b-modal>-->
<!--                        </div>-->
                        <div class="d-flex flex-row">
                            <div class="my-auto">
                                <div class="d-inline-block mb-4">
                                    <h5 class="d-inline">Total Clients | {{ dashboardData.attributes.clients.total }}</h5>
                                    <span class="text-small d-block">From the Beginning</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <b-progress variant="secondary" class="mb-2"
                                        :value="dashboardData.attributes.clients.noshows.percentage"></b-progress>
                            <span>
                                No-shows | {{ dashboardData.attributes.clients.noshows.count }}
                                <span class="float-right">{{ dashboardData.attributes.clients.noshows.percentage }}%</span>
                            </span>
                        </div>
                    </b-card>
                </b-colxx>

                <b-colxx lg="4" class="mb-4">
                    <b-card class="bg-theme-3">
<!--                        <div class="position-absolute card-top-buttons">-->
<!--                            <div v-b-modal.modalbasic-3 class="btn btn-header-light-2 icon-button mt-n4 mr-n4">-->
<!--                                <i class="simple-icon-info" />-->
<!--                            </div>-->
<!--                            <b-modal id="modalbasic-3" ref="modalbasic-3" title="Occupency">-->
<!--                                Lorem ipsum dolor sit amet, consectetur adipisicing elit,-->
<!--                                sed do eiusmod tempor incididunt ut labore et dolore magna-->
<!--                                aliqua. Ut enim ad minim veniam, quis nostrud exercitation-->
<!--                                ullamco laboris nisi ut aliquip ex ea commodo consequat.-->
<!--                                Duis aute irure dolor in reprehenderit in voluptate velit-->
<!--                                esse cillum dolore eu fugiat nulla pariatur. Excepteur-->
<!--                                sint occaecat cupidatat non proident, sunt in culpa qui-->
<!--                                officia deserunt mollit anim id est laborum. Nehan...-->
<!--                                <template slot="modal-footer">-->
<!--                                    <b-button variant="secondary" @click="hideModal('modalbasic-3')">Okay!</b-button>-->
<!--                                </template>-->
<!--                            </b-modal>-->
<!--                        </div>-->
                        <div class="d-flex flex-row">
                            <div class="my-auto">
                                <div class="d-inline-block mb-4">
                                    <h5 class="d-inline">Total Occupied | {{ dashboardData.attributes.units.total_occupied }}</h5>
                                    <span class="text-small d-block">Currently Occupied Units</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <b-progress variant="secondary" class="mb-2"
                                        :value="dashboardData.attributes.units.vacant.percentage"></b-progress>
                            <span>
                                Vacant Units | {{ dashboardData.attributes.units.vacant.count }}
                                <span class="float-right">{{dashboardData.attributes.units.vacant.percentage}}%</span>
                            </span>
                        </div>
                    </b-card>
                </b-colxx>
            </div>

            <b-row>
                <b-colxx xxs="12" lg="12">
                    <b-card v-if="!chartLoading" class="mb-4">
                        <div class="d-flex flex-row">
                            <i class="iconsminds-bar-chart-4 text-large mb-4 mr-3 menu-icon-style"/>
                            <div class="my-auto">
                                <div class="d-inline-block mb-4">
                                    <h5 class="d-inline">CLIENT'S STATUS</h5>
                                    <span class="text-muted text-small d-block">Last Six Months</span>
                                </div>
                            </div>
                        </div>

                        <bar-shadow-chart :data="barChartData" :height="277"/>
                    </b-card>
                </b-colxx>

                <template v-if="false"> // map set to hidden
                    <b-colxx xxs="12" lg="6">
                        <b-card v-if="maps" class="mb-4" no-body>
                            <GmapMap
                                :center="center"
                                :zoom="10"
                                map-type-id="roadmap"
                                class="map-item"
                                :options="theme === 'dark' ? mapStyles : {}"
                            >
                                <gmap-marker
                                    :key="key"
                                    v-for="(marker, key) in maps"
                                    :position="marker.data.attributes.position"
                                    :clickable="true"
                                    @click="toggleInfo(marker.data.attributes, key)"

                                />
                                <gmap-info-window :options="{pixelOffset: {width: 0,height: -35}}" :position="infoPosition"
                                                  :opened="window_open" @closeclick="window_open=false">
                                    <span v-html="infoContent"></span>
                                </gmap-info-window>
                            </GmapMap>
                        </b-card>
                    </b-colxx>
                </template>
<!--                <b-colxx xxs="12" lg="4" class="mb-4">-->
<!--                    <b-card no-body>-->
<!--                        <b-card-body>-->
<!--                            <div class="float-left float-none-xs">-->
<!--                                <div class="d-flex flex-row">-->
<!--                                    <i class="iconsminds-24-hour text-large mb-4 mr-3 menu-icon-style"/>-->
<!--                                    <div class="my-auto">-->
<!--                                        <div class="d-inline-block mb-4">-->
<!--                                            <h5 class="d-inline">User Activities</h5>-->
<!--                                            <span class="text-muted text-small d-block">Based on Histories</span>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <vue-perfect-scrollbar class="activity-logs-dashboard scroll"-->
<!--                                                       :settings="{ suppressScrollX: true, wheelPropagation: true }">-->
<!--                                    <div>-->
<!--                                        <ul class="timeline">-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 10, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    <p><a href="#">Demo Administrator</a> - Added new Facility-->
<!--                                                        <a href="#">Mv52- 125 West 123rd Street</a><br>-->
<!--                                                        Vendor:-->
<!--                                                        <a href="#">RMC Property Management</a></p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 9, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    <p><a href="#">Demo Administrator</a> - Commented to Client <a href="#">CLT004550- DEMO RESIDENT</a></p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 8, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,-->
<!--                                                        accumsan a, consectetuer eget, posuere ut, mauris. Donec-->
<!--                                                        orci lectus, aliquam ut, faucibus non, euismod id,-->
<!--                                                        nulla. Donec vitae sapien ut libero venenatis faucibus.-->
<!--                                                        ullam dictum felis-->
<!--                                                        eu pede mollis pretium. Pellentesque ut neque. </p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 7, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    &lt;!&ndash;                                                                    <h5 class="timeline-title">Event Title</h5>&ndash;&gt;-->
<!--                                                    <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,-->
<!--                                                        accumsan a, consectetuer eget, posuere ut, mauris. Donec-->
<!--                                                        orci lectus, aliquam ut, faucibus non, euismod id,-->
<!--                                                        nulla. Donec vitae sapien ut libero venenatis faucibus.-->
<!--                                                        ullam dictum felis-->
<!--                                                        eu pede mollis pretium. Pellentesque ut neque. </p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 6, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    &lt;!&ndash;                                                                    <h5 class="timeline-title">Event Title</h5>&ndash;&gt;-->
<!--                                                    <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,-->
<!--                                                        accumsan a, consectetuer eget, posuere ut, mauris. Donec-->
<!--                                                        orci lectus, aliquam ut, faucibus non, euismod id,-->
<!--                                                        nulla. Donec vitae sapien ut libero venenatis faucibus.-->
<!--                                                        ullam dictum felis-->
<!--                                                        eu pede mollis pretium. Pellentesque ut neque. </p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 5, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    <p><a href="#">Demo Administrator</a> - Added new Facility-->
<!--                                                        <a href="#">Mv52- 125 West 123rd Street</a><br>-->
<!--                                                        Vendor:-->
<!--                                                        <a href="#">RMC Property Management</a></p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 4, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    <p><a href="#">Demo Administrator</a> - Commented to Client <a href="#">CLT004550- DEMO RESIDENT</a></p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 3, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,-->
<!--                                                        accumsan a, consectetuer eget, posuere ut, mauris. Donec-->
<!--                                                        orci lectus, aliquam ut, faucibus non, euismod id,-->
<!--                                                        nulla. Donec vitae sapien ut libero venenatis faucibus.-->
<!--                                                        ullam dictum felis-->
<!--                                                        eu pede mollis pretium. Pellentesque ut neque. </p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 2, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    &lt;!&ndash;                                                                    <h5 class="timeline-title">Event Title</h5>&ndash;&gt;-->
<!--                                                    <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,-->
<!--                                                        accumsan a, consectetuer eget, posuere ut, mauris. Donec-->
<!--                                                        orci lectus, aliquam ut, faucibus non, euismod id,-->
<!--                                                        nulla. Donec vitae sapien ut libero venenatis faucibus.-->
<!--                                                        ullam dictum felis-->
<!--                                                        eu pede mollis pretium. Pellentesque ut neque. </p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                            <li class="timeline-item">-->
<!--                                                <div class="timeline-info">-->
<!--                                                    <span>November 1, 2020</span>-->
<!--                                                </div>-->
<!--                                                <div class="timeline-marker"></div>-->
<!--                                                <div class="timeline-content">-->
<!--                                                    &lt;!&ndash;                                                                    <h5 class="timeline-title">Event Title</h5>&ndash;&gt;-->
<!--                                                    <p>Nullam vel sem. Nullam vel sem. Integer ante arcu,-->
<!--                                                        accumsan a, consectetuer eget, posuere ut, mauris. Donec-->
<!--                                                        orci lectus, aliquam ut, faucibus non, euismod id,-->
<!--                                                        nulla. Donec vitae sapien ut libero venenatis faucibus.-->
<!--                                                        ullam dictum felis-->
<!--                                                        eu pede mollis pretium. Pellentesque ut neque. </p>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                        </ul>-->
<!--                                    </div>-->
<!--                                </vue-perfect-scrollbar>-->
<!--                            </div>-->
<!--                        </b-card-body>-->
<!--                    </b-card>-->
<!--                </b-colxx>-->
            </b-row>

            <div class="row">
                <b-colxx lg="9" class="mb-4">
                    <b-card no-body>
                        <b-card-body>
                            <div class="d-flex flex-row">
                                <i class="iconsminds-magnifi-glass-- text-large mb-4 mr-3 menu-icon-style"/>
                                <div class="my-auto">
                                    <div class="d-inline-block mb-4">
                                        <h5 class="d-inline">UPCOMING FOLLOW-UP INSPECTIONS</h5>
                                        <span class="text-small d-block">Corrective Action Plans</span>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div v-if="upcomingInspections.length <= 0" class="inspection-info-dashboard" >
                                    <p>There are no upcoming inspections to show.</p>
                                </div>

                                <vue-perfect-scrollbar v-else class="inspection-info-dashboard scroll"
                                                       :settings="{ suppressScrollX: true, wheelPropagation: true }">
                                    <b-table :fields="upcomingInspectionsTable.fields" :items="upcomingInspections">
                                        <template v-slot:cell(id)="data">
                                            <router-link class="text-data-link" :to="'/hms/inspections/' + data.item.links.self"
                                                         v-text="data.item.data.attributes.code"/>
                                        </template>

                                        <template v-slot:cell(facility)="data">
                                            <span v-text="data.item.data.attributes.facility"/>
                                        </template>

                                        <template v-slot:cell(vendor)="data">
                                            <span v-text="data.item.data.attributes.vendor"/>
                                        </template>

                                        <template v-slot:cell(outcome)="data">
                                            <span v-text="data.item.data.attributes.outcome"/>
                                        </template>

                                        <template v-slot:cell(cap_due)="data">
                                            <span v-text="data.item.data.attributes.cap_due"/>
                                        </template>

                                        <template v-slot:cell(inspector)="data">
                                            <span v-text="data.item.data.attributes.inspector"/>
                                        </template>
                                    </b-table>
                                </vue-perfect-scrollbar>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-colxx>

                <b-colxx lg="3" class="mb-4">
                    <b-card class="inspection-info-dashboard-2 bg-theme-2">
                        <b-row class="align-items-center h-100">
                            <b-colxx md="12" class="text-right" style="font-size: 48px">{{ dashboardData.attributes.inspections.total }}<br>
                                <div class="text-small mt-n3 mb-5" style="font-size: 12px">
                                    TOTAL INSPECTIONS<br>From the Beginning
                                </div>
                            </b-colxx>
                            <br><br><br><br>

                            <b-colxx md="12">
                                <div class="text-right">
                                    <b-badge variant="outline-light" pill class="mr-1">INITIAL |
                                        {{ dashboardData.attributes.inspections.initials }}
                                    </b-badge>
                                    <b-badge variant="outline-light" pill class="">FOLLOW-UP |
                                        {{ dashboardData.attributes.inspections.followups }}
                                    </b-badge>
                                </div>
                            </b-colxx>
                        </b-row>
                    </b-card>
                </b-colxx>
            </div>

            <b-card v-if="latest" class="mb-4 d-none d-sm-block">
                <div class="d-flex flex-row">
                    <i class="iconsminds-big-data text-large mb-4 mr-3 menu-icon-style"/>
                    <div class="my-auto">
                        <div class="d-inline-block mb-4">
                            <h5 class="d-inline">LATEST FIVE</h5>
                            <span class="text-muted text-small d-block">Aspect in All Form's Data</span>
                        </div>
                    </div>
                </div>

                <b-tabs card>
                    <b-tab no-body title="Facilities" active>
                        <LatestFacilities :data="latest.facilities.data"/>
                    </b-tab>
                    <b-tab no-body title="Units">
                        <LatestUnits :data="latest.units.data"/>
                    </b-tab>
                    <b-tab no-body title="Clients">
                        <LatestClients :data="latest.clients.data"/>
                    </b-tab>
                    <b-tab no-body title="Referrals">
                        <LatestReferrals :data="latest.referrals.data"/>
                    </b-tab>
                    <b-tab no-body title="Admissions">
                        <LatestAdmissions :data="latest.admissions.data"/>
                    </b-tab>
                    <b-tab no-body title="Discharges">
                        <LatestDischarges :data="latest.discharges.data"/>
                    </b-tab>
                    <b-tab no-body title="No-shows">
                        <LatestNoShows :data="latest.noshows.data"/>
                    </b-tab>
                    <b-tab no-body title="Inspections">
                        <LatestInspections :data="latest.inspections.data"/>
                    </b-tab>
                    <b-tab no-body title="Billings">
                        <LatestBillings :data="latest.billings.data"/>
                    </b-tab>
                    <b-tab no-body title="Signatures">
                        <LatestSignatures :data="latest.signatures.data"/>
                    </b-tab>
                </b-tabs>
            </b-card>

            <b-row>
                <b-colxx xxs="12">
                    <b-card v-if="!chartLoading">
                        <div class="d-flex flex-row">
                            <i class="iconsminds-line-chart-3 text-large mb-4 mr-3 menu-icon-style"/>
                            <div class="my-auto">
                                <div class="d-inline-block mb-4">
                                    <h5 class="d-inline">BILLINGS</h5>
                                    <span class="text-muted text-small d-block">Last Six Months</span>
                                </div>
                            </div>
                        </div>

                        <area-shadow-chart :data="billingChartData" :prefix="'$'" :height="250"/>
                    </b-card>
                </b-colxx>
            </b-row>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    import GradientWithRadialProgressCard from "../../../components/Cards/GradientWithRadialProgressCard";
    import RadarChart from "../../../components/Charts/Radar";
    import BarShadowChart from "../../../components/Charts/BarShadow";
    import AreaShadowChart from '../../../components/Charts/AreaShadow';
    import RadialProgressCard from '../../../components/Cards/RadialProgressCard';
    import LatestFacilities from "./LatestFacilities";
    import LatestUnits from "./LatestUnits";
    import LatestClients from "./LatestClients";
    import LatestReferrals from "./LatestReferrals";
    import LatestAdmissions from "./LatestAdmissions";
    import LatestDischarges from "./LatestDischarges";
    import LatestNoShows from "./LatestNoShows";
    import LatestInspections from "./LatestInspections";
    import LatestBillings from "./LatestBillings";
    import LatestSignatures from "./LatestSignatures";
    import GradientCard from '../../../components/Cards/GradientCard';

    import {mapStyles} from "../../../data/mapStyles";

    export default {
        components: {
            'area-shadow-chart': AreaShadowChart,
            'radial-progress-card': RadialProgressCard,
            'radar-chart': RadarChart,
            'bar-shadow-chart': BarShadowChart,
            'gradient-card': GradientCard,
            "gradient-with-radial-progress-card": GradientWithRadialProgressCard,
            LatestSignatures,
            LatestBillings,
            LatestInspections,
            LatestNoShows,
            LatestDischarges,
            LatestAdmissions,
            LatestReferrals,
            LatestClients,
            LatestUnits,
            LatestFacilities,

        },
        created() {
            // Check if dark or light theme
            if (localStorage.getItem('theme_selected_color')) {
                this.theme = localStorage.getItem('theme_selected_color').split(".")[0];
            }

            this.getDashboardData();
        },

        data() {
            return {
                upcomingInspectionsTable: {
                    fields: [
                        {key: 'id', label: 'Code', tdClass: ''},
                        {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                        {key: 'vendor', label: 'Vendor', tdClass: 'text-muted'},
                        {key: 'outcome', label: 'Latest Outcome', tdClass: 'text-muted'},
                        {key: 'cap_due', label: 'CAP Due Date', tdClass: 'text-muted'},
                        {key: 'inspector', label: 'Inspector', tdClass: 'text-muted'},
                    ]
                },
                upcomingInspections: [],
                loading: true,
                chartLoading: true,
                theme: 'light',
                todoForm: {
                    title: '',
                },
                todoErrors: {},
                dashboardData: null,
                todos: [],
                maps: null,
                latest: null,
                chart: null,
                center: {
                    lat: 40.780610,
                    lng: -73.935242
                },
                info_marker: null,
                infoCurrentKey: null,
                infoPosition: null,
                infoContent: null,
                window_open: false,
                mapStyles,
            }
        },

        computed: {
            ...mapGetters({
                authUserInfo: 'authUserInfo',
                colors: 'getThemeColors',
            }),

            barChartData() {
                let payload = this.chart;

                let slices = [payload.referrals, payload.noshows, payload.admissions, payload.discharges, payload.transfers];

                let barChartData = {
                    labels: payload.labels,
                    datasets: [],
                };

                let colorPallete = 1;

                slices.forEach((slice) => {
                    if (colorPallete === 7) colorPallete = 1;

                    barChartData.datasets.push({
                        label: slice.label,
                        data: slice.data,
                        borderColor: this.colors['themeColor' + colorPallete],
                        backgroundColor: this.colors['themeColor' + colorPallete + '_10'],
                        borderWidth: 1
                    });
                    colorPallete++;
                });

                return barChartData;
            },

            radarChartData() {
                return {
                    datasets: [
                        {
                            label: 'Vacancy',
                            borderWidth: 2,
                            pointBackgroundColor: this.colors.themeColor1,
                            borderColor: this.colors.themeColor1,
                            backgroundColor: this.colors.themeColor1_10,
                            data: [180, 190, 170]
                        },
                        {
                            label: 'Occupancy',
                            borderWidth: 2,
                            pointBackgroundColor: this.colors.themeColor2,
                            borderColor: this.colors.themeColor2,
                            backgroundColor: this.colors.themeColor2_10,
                            data: [112, 130, 195]
                        }
                    ],
                    labels: ['January, 2020', 'February, 2020', 'March, 2020']
                };
            },

            billingChartData() {
                let payload = this.chart.billings;

                return {
                    labels: payload.labels,
                    datasets: [{
                        data: payload.data,
                        borderColor: this.colors.themeColor1,
                        pointBackgroundColor: this.colors.foregroundColor,
                        pointBorderColor: this.colors.themeColor1,
                        pointHoverBackgroundColor: this.colors.themeColor1,
                        pointHoverBorderColor: this.colors.foregroundColor,
                        backgroundColor: this.colors.themeColor1_10,
                        pointRadius: 4,
                        pointBorderWidth: 2,
                        pointHoverRadius: 5,
                        fill: true,
                        borderWidth: 2
                    }],
                };
            },
        },

        methods: {
            hideModal (refname) {
                this.$refs[refname].hide()
                console.log('hide modal:: ' + refname)

                if (refname === 'modalnestedinline') {
                    this.$refs['modalnested'].show()
                }
            },
            getDashboardData() {
                axios.get('/api/hms/dashboard')
                    .then(response => {
                        this.dashboardData = response.data.data;
                    })
                    .finally(responses => {
                        this.loading = false;
                    });

                axios.get('/api/hms/dashboard/upcoming-inspections')
                    .then(response => {
                        this.upcomingInspections = response.data.data;
                    })
                    .finally(responses => {
                        this.loading = false;
                    });

                axios.get('/api/hms/dashboard/latest')
                    .then(response => {
                        this.latest = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });

                axios.get('/api/hms/dashboard/chart')
                    .then(response => {
                        this.chart = response.data;
                        this.chartLoading = false;
                    })
                    .catch(error => {
                        console.log(error);
                    });

                axios.get('/api/hms/todos')
                    .then(response => {
                        this.todos = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });

                axios.get('/api/hms/locations/facilities/maps')
                    .then(response => {
                        this.maps = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            addNewTodo() {
                axios.post('/api/hms/todos', this.todoForm)
                    .then(response => {
                        this.todos.unshift(response.data);
                        this.todoForm.title = '';
                    })
                    .catch(errors => {
                        this.todoErrors = errors.response.data.errors;
                        this.$root.$emit('bv::show::tooltip', 'todo-error');
                    });
            },
            editTodo(todo_id, index) {
                const completed = {
                    completed: this.todos[index].data.attributes.completed,
                };
                axios.patch('/api/hms/todos/' + todo_id, completed)
                    .catch(error => {
                        console.log(error);
                    });
            },
            deleteTodo(todo_id, completed, index) {
                if (completed) {
                    axios.delete('/api/hms/todos/' + todo_id)
                        .finally(responses => {
                            this.todos.splice(index, 1);
                        });
                }
            },
            getPosition: function (marker) {
                return {
                    lat: parseFloat(marker.position.lat),
                    lng: parseFloat(marker.position.lng)
                }
            },
            toggleInfo: function (marker, key) {
                this.infoPosition = this.getPosition(marker);
                this.infoContent = marker.info;
                if (this.infoCurrentKey === key) {
                    this.window_open = !this.window_open;
                } else {
                    this.window_open = true;
                    this.infoCurrentKey = key;
                }
            },
            greetings() {
                let currentHour = new Date().getHours();

                if (currentHour >= 0 && currentHour < 6) {
                    return "What are you doing so early, ";
                } else if (currentHour >= 6 && currentHour < 12) {
                    return "Good morning, ";
                } else if (currentHour >= 12 && currentHour < 17) {
                    return "Good afternoon, ";
                } else if (currentHour >= 17 && currentHour < 24) {
                    return "Good evening, ";
                }
            },
            ...mapActions(["retrieveToken"]),
        },
    }
</script>
